import * as React from "react";
import {connect} from "react-redux";
import update from 'immutability-helper';
import {Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import * as ClientsAction from "../actions/ClientActions";
import * as ProjectsAction from "../actions/ProjectActions";
import * as TaskActions from "../actions/TaskActions";
import * as utils from "../utils";
import HoursFormControl from "../components/HoursFormControl";
import * as MessageActions from "../actions/MessageActions";
import Loading from "../components/Loading";
import * as queryString from "query-string";
import {ALL_TIME_TEXT_URL} from "../constants";

class TasksPage extends React.Component{

    defaultFormData = {
        id: undefined,
        label: "",
        name: "",
        budgetMinutes: "",
    };

    constructor(){
        super();

        this.state = {
            form: this.defaultFormData,
            message: undefined,
            waiting: false,
        }
    }

    componentWillMount(){
        this.loadData();
    }

    componentDidUpdate(){
        this.loadData();
    }

    loadData(){
        const {props} = this;

        if(props.match.params && props.match.params.project_id){
            const {project_id} = props.match.params;

            this.props.fetchTasksIfNeeded(project_id);
            this.props.fetchProjectsIfNeeded();
            this.props.fetchClientsIfNeeded()
        }

        if(props.match.params && props.match.params.task_id){
            this.fetchEditTask();
        }

        if(props.match.params && !props.match.params.task_id && this.state.form.id){
            this.setState({form: this.defaultFormData})
        }
    }

    componentWillReceiveProps(newProps){
        const {project_id} = this.props.match.params;
        if(this.state.waiting && !newProps.tasks.createFetching){
            this.setState({waiting: false});
            this.props.history.push("/tasks/" + project_id)
        }

        this.fetchEditTask(newProps);

        if (newProps.message && newProps.message.message) {
            setTimeout(() => this.props.closeMessage(), 3000);
        }
    }

    goToTaskPage(task){
        const {project_id} = this.props.match.params;
        this.props.history.push("/tasks/" + project_id + "/task/" + task.id)
    }

    save(event){
        event.preventDefault();

        if(!this.state.form.name){
            this.setState({message: {type: "warning", "title": "Error", message: "Please enter a name."}});
            return;
        }

        const {project_id} = this.props.match.params;

        let formData = Object.assign({}, this.state.form);
        formData.project_id = project_id;
        formData.client_id = this.props.projects.items[project_id].client.id;
        formData.budgetMinutes = HoursFormControl.parseHoursToMinutes(formData.budgetHours);

        this.setState(update(this.state, {
            form: {$set: this.defaultFormData},
            // message: {$set: {type: "success", title: "Success", message: "Task successfully added."}},
            waiting: {$set: true},
        }));
        this.props.saveTask(formData);
    }
    cancel() {
        const {project_id} = this.props.match.params;
        this.props.history.push("/tasks/" + project_id)
    }

    fetchEditTask(props){
        props = props || this.props;


        if(props.match.params && props.match.params.task_id && this.state.form.id !== props.match.params.task_id){
            const {tasks} = props;
            if(tasks.fetched && tasks.items[props.match.params.task_id]) {
                const task = tasks.items[props.match.params.task_id];
                task.budgetHours = HoursFormControl.parseMinutesToHours(task.budgetMinutes);

                this.setState(update(this.state, {
                    form: {$merge: task}
                }))
            }
        }
    }

    toReporting() {
        const task = this.props.tasks.items[this.props.match.params.task_id];
        this.props.history.push({
            pathname: "/reporting",
            search: queryString.stringify({
                client: task.client.id,
                project: task.project.id,
                task: task.id,
                from: ALL_TIME_TEXT_URL,
                to: ALL_TIME_TEXT_URL,
            })
        });
    }

    handleChange(event) {
        this.setState(update(this.state, {
            form: {
                [event.target.name]: {$set: event.target.value}
            }
        }));
    }

    render(){

        const message = this.state.message || this.props.message;
        const {tasks, projects} = this.props;
        const {project_id} = this.props.match.params;

        const taskArray = Object.values(tasks.items).filter(task => task.project.id === project_id).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        const project = projects.fetched && projects.items[project_id];

        const readyToEdit = (this.props.match.params.task_id && this.state.form.id) || !this.props.match.params.task_id;

        return readyToEdit ? (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Tasks <small>{project && project.name}</small>
                        {this.state.waiting ? (
                            <Loading right loading />
                        ) : (
                            <NavLink to={"/projects/" + project.id} className="pull-right">
                                <Button  bsStyle="default">
                                    <Glyphicon glyph="remove"/>&nbsp;
                                    Cancel
                                </Button>
                            </NavLink>
                        )}
                    </h1>
                </div>
                <div className="card-body">

                    {message && message.message && (
                        <Alert bsStyle={message.type} onDismiss={() => {this.setState({message: null}); this.props.closeMessage()}}>
                            <h4>{message.title}</h4>
                            {message.message}
                        </Alert>
                    )}
                    {this.props.projects.createFetching ? (
                        <div>Saving...</div>
                    ) : (
                        <Form onSubmit={this.save.bind(this)}>
                            {/*<FormGroup>*/}
                                {/*<Row>*/}
                                    {/*<Col sm={4}>*/}
                                        {/*Task label*/}
                                    {/*</Col>*/}
                                    {/*<Col sm={8}>*/}
                                        {/*<FormControl componentClass="input" name="label" value={this.state.form.label || ""} onChange={this.handleChange.bind(this)} />*/}
                                    {/*</Col>*/}
                                {/*</Row>*/}
                            {/*</FormGroup>*/}
                            <FormGroup>
                                <Row>
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Task name
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl componentClass="input" name="name" value={this.state.form.name} onChange={this.handleChange.bind(this)} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Budget (hours)
                                    </Col>
                                    <Col sm={8}>

                                        <HoursFormControl name="budgetHours"
                                                          value={this.state.form.budgetHours || ""}
                                                          onChange={this.handleChange.bind(this)} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={8} smOffset={4}>
                                        <Button bsStyle="primary" type="submit">
                                            <Glyphicon glyph="ok"/>&nbsp;
                                            {this.props.match.params.task_id ?
                                                "Save" : "Add"
                                            }
                                        </Button>
                                        {" "}
                                        {this.props.match.params.task_id && (
                                            <Button onClick={this.cancel.bind(this)}>
                                                <Glyphicon glyph="remove"/>&nbsp;
                                                Cancel
                                            </Button>
                                        )}
                                        {this.props.match.params.task_id && (
                                            <Button onClick={this.toReporting.bind(this)} className="pull-right">
                                                <Glyphicon glyph="list"/>&nbsp;
                                                Show entries
                                            </Button>
                                        )}
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    )}
                </div>
                {taskArray.length > 0 && (
                    <table className="table table-striped">
                        <thead>
                        <tr className="entry-table-head">
                            {/*<th>Label</th>*/}
                            <th>Name</th>
                            <th>Budget</th>
                            <th>Total hours</th>
                        </tr>
                        </thead>
                        <tbody>
                        {taskArray.map((task, id) => {
                            return (<tr key={id} className="hoverable" onClick={this.goToTaskPage.bind(this, task)}>
                                {/*<th>*/}
                                    {/*<Label>{task.label}</Label>*/}
                                {/*</th>*/}
                                <th>
                                    {task.name}
                                </th>
                                <td>
                                    {utils.formatHours(task.budgetMinutes)}
                                </td>
                                <td>
                                    {utils.formatHours(task.minutesTotal)}
                                </td>
                            </tr>);
                        })}
                        </tbody>
                    </table>
                )}
            </div>
        ) : (
            <div>No clients yet</div>
        )
    }
}

export default connect(state => ({
    clients: state.clients,
    projects: state.projects,
    tasks: state.tasks,
    message: state.message,
}), dispatch => ({
    fetchClientsIfNeeded: () => dispatch(ClientsAction.fetchClientsIfNeeded()),
    fetchProjectsIfNeeded: () => dispatch(ProjectsAction.fetchProjectsIfNeeded()),
    fetchTasksIfNeeded: project => dispatch(TaskActions.fetchTasksIfNeeded(project, project)),
    saveTask: project => dispatch(TaskActions.saveTask(project)),
    closeMessage: () => dispatch(MessageActions.closeMessage()),
}))(TasksPage);


// WEBPACK FOOTER //
// ./src/pages/TasksPage.js